import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import {
	CheckCircleIcon,
	ChevronRightIcon,
	ExclamationTriangleIcon,
} from '@heroicons/react/24/outline';

import WidgetBase, { BaseList } from './WidgetBase';

import { classNames } from '../helpers/functions';
import useModal from '../../hooks/useModal';

const ContractWidget = ({ ...data }) => {
	const navigate = useNavigate();
	const { setOpen: openContractModal } = useModal('contractOverview');

	const visibleContracts = data?.item?.contracts?.filter(
		(contract) => contract?.active && moment().isAfter(contract?.startDate)
	);

	return (
		<WidgetBase
			cols={2}
			rows={4}
			title="Contracts"
			menuItems={[
				{
					name: 'View All',
					onClick: () => navigate(`/manage/contracts`),
				},
			]}
			isEmpty={!visibleContracts.length}
			isEmptyMessage={'No contracts found'}
			flexCenter={!visibleContracts.length}
		>
			<BaseList
				items={visibleContracts?.map((contract) => {
					const isExpired = moment().isAfter(contract?.endDate);
					const isExpiringSoon = moment().isAfter(
						moment(contract?.endDate).subtract(30, 'days')
					);
					return {
						children: (
							<div
								className="grid grid-cols-2 gap-x-6 flex-1 py-2 cursor-pointer"
								onClick={() => openContractModal({ id: contract?.id })}
							>
								<div
									className={classNames(
										'flex items-center',
										isExpired
											? 'text-red-400'
											: isExpiringSoon
											? 'text-orange-400'
											: 'text-gray-600'
									)}
								>
									{isExpired ? (
										<ExclamationTriangleIcon className="text-red-500 w-5 h-5 mr-3" />
									) : isExpiringSoon ? (
										<ExclamationTriangleIcon className="text-orange-400 w-5 h-5 mr-3" />
									) : (
										<CheckCircleIcon className="text-green-500 w-5 h-5 mr-3" />
									)}{' '}
									<div className="flex flex-col">
										<div>{contract?.name}</div>
										{contract?.category && (
											<div className="text-xxs text-gray-400">
												{contract?.category?.name}
											</div>
										)}
									</div>
								</div>
								<div
									className={classNames(
										'flex justify-between items-center',
										isExpired
											? 'text-red-400'
											: isExpiringSoon
											? 'text-orange-400'
											: 'text-gray-500'
									)}
								>
									<div>
										{moment(contract?.endDate).format('dddd, MMM Do, YYYY')}

										<div className="text-xxs font-base text-gray-400">
											{moment(contract?.endDate).fromNow()}
										</div>
									</div>
									<div>
										<ChevronRightIcon className="text-gray-500 w-3 h-3" />
									</div>
								</div>
							</div>
						),
					};
				})}
			/>{' '}
		</WidgetBase>
	);
};

export default ContractWidget;
